export const RENDER_SHORT_CODE_REGEX = /\[(.*?)\]/;
export const ATTRIBUTE_REGEX = /(\w+)=["']([^"']*)["']/g;
export const PARSE_SHORT_CODE_REGEX = /\[(\w+)(.*?)\]/g;
export const REPLACE_SHORT_CODE_REGEX = /\[(video|audio)\s+id='(\d+)'\]/g;
export const REPLACE_SHORT_CODE_REGEX_WP = /\[[^\]]+\]/g;
